import {
  ADD_MESSAGE,
  SET_ACTIVE_CHAT,
  SET_IS_TYPING,
  SET_SHOW_WELCOME_TEXT,
  UPDATE_CHAT,
  UPDATE_QUESTIONID,
  SET_ACTIVE_QUESTION,
  SET_FEEDBACK,
  SET_IS_ARCHIVED,
} from "../actions/chatActions";

const initialState = {
  messages: [],
  activeChatId: null,
  showWelcomeText: true,
  isTyping: false,
  activeQuestionId: null,
  isArchived: false,
};

const chatReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ADD_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };
    case "CLEAR_MESSAGES":
      return {
        ...state,
        messages: [],
      };
    case SET_SHOW_WELCOME_TEXT:
      return {
        ...state,
        showWelcomeText: action.payload,
      };
    case SET_IS_TYPING:
      return {
        ...state,
        isTyping: action.payload,
      };
    case SET_ACTIVE_CHAT:
      return {
        ...state,
        activeChatId: action.payload,
      };
    case UPDATE_QUESTIONID:
      return {
        ...state,
        messages: state.messages.map((message: any, index) =>
          index === state.messages.length - 1
            ? { ...message, question_id: action.payload.question_id }
            : message
        ),
      };
    case UPDATE_CHAT:
      return {
        ...state,
        messages: state.messages.map((message: any) =>
          message.question_id === action.payload.question_id &&
          message.sender === action.payload.sender
            ? { ...message, text: [...message.text, action.payload.text] }
            : message
        ),
      };
    case SET_ACTIVE_QUESTION:
      return {
        ...state,
        activeChatId: action.payload.chatId,
        activeQuestionId: action.payload.questionId,
      };
    case SET_FEEDBACK:
      const feedbackParser = (feedback: Array<any> | null) => {
        if (Array.isArray(feedback)) {
          return feedback;
        }
        return [];
      };
      return {
        ...state,
        messages: state.messages.map((message: any) =>
          message.question_id === action.payload.questionId &&
          message.sender === false
            ? {
                ...message,
                feedback: [
                  ...feedbackParser(message.feedback),
                  ...action.payload.feedback,
                ],
              }
            : message
        ),
      };
    case SET_IS_ARCHIVED:
      return {
        ...state,
        isArchived: action.payload,
      };
    default:
      return state;
  }
};

export default chatReducer;
